import { API, Auth } from 'aws-amplify';

async function getToken() {
    return (await Auth.currentSession()).getIdToken().getJwtToken();
}
let allOrders = [];

export function invalidateCache() {
    allOrders = [];
    allMissingPostalCodes = [];
}

export async function getAllOrdersForExport() {
    if (allOrders.length === 0) {
        await getAll();
    }
    return allOrders;
}

export async function getSummary() {
    if (allOrders.length === 0) {
        allOrders = await API.get('orders', `/prod/orders`, {
            headers: {
                Authorization: await getToken(),
            },
        });
        allOrders.sort((a, b) => (a.dateCreated > b.dateCreated ? -1 : b.dateCreated > a.dateCreated ? 1 : 0));
        for (let i = 0; i < allOrders.length; i++) {
            allOrders[i].orderType = allOrders[i].deliveryTime ? 'Recogida en tienda' : 'Entrega a domicílio';
        }
    }
    let summary = {};
    for (let order of allOrders) {
        let key = order.customer.name + order.customer.surname + order.customer.surname2;
        if (order.customer.loyaltyCode !== undefined) {
            key = order.customer.loyaltyCode;
        }
        if (summary[key] === undefined) {
            summary[key] = { customer: order.customer, amount: 0, numOrders: 0 };
        } else {
            console.log(key);
        }
        summary[key].amount += order.amount;
        summary[key].amount = summary[key].amount;
        summary[key].numOrders++;
    }

    // To Array
    summary = Object.values(summary);
    summary.sort((a, b) => (a.amount > b.amount ? -1 : b.amount > a.amount ? 1 : 0));
    for (let k in summary) {
        summary[k].amount = Number.parseFloat(summary[k].amount).toFixed(2);
    }
    return summary;
}

export async function getAll(page, pageSize, search) {
    if (allOrders.length === 0 || page === 0 || page === undefined) {
        allOrders = await API.get('orders', `/prod/orders`, {
            headers: {
                Authorization: await getToken(),
            },
        });
        allOrders.sort((a, b) => (a.dateCreated > b.dateCreated ? -1 : b.dateCreated > a.dateCreated ? 1 : 0));
        for (let i = 0; i < allOrders.length; i++) {
            allOrders[i].orderType = allOrders[i].deliveryTime ? 'Recogida en tienda' : 'Entrega a domicílio';
        }
    }

    let total = 0;
    for (let o of allOrders) {
        total += o.amount;
    }
    console.log('TOTAL:', total);

    if (search) {
        search = search.toLowerCase();
        let filteredData = allOrders.filter((line) => {
            for (let k of Object.keys(line)) {
                if (typeof line[k] === 'string') {
                    if (line[k].toLowerCase().indexOf(search) !== -1) return true;
                } else if (typeof line[k] === 'number') {
                    if (line[k].toString().indexOf(search) !== -1) return true;
                }
            }
            if (line.customer.name.toLowerCase().indexOf(search) !== -1) return true;
            if (line.customer.surname && line.customer.surname.toLowerCase().indexOf(search) !== -1) return true;
            if (line.customer.surname2 && line.customer.surname2.toLowerCase().indexOf(search) !== -1) return true;
            return false;
        });
        return { data: filteredData.slice(pageSize * (page - 1), pageSize * (page - 1) + pageSize), page, total: filteredData.length };
    }

    return { data: allOrders.slice(pageSize * (page - 1), pageSize * (page - 1) + pageSize), page, total: allOrders.length };
}
export async function get(orderId) {
    return await API.get('orders', `/prod/order/${orderId}`, {
        headers: {
            Authorization: await getToken(),
        },
    });
}

let allMissingPostalCodes = [];
export async function getMissingPostalCodes(page, pageSize, search) {
    if (allMissingPostalCodes.length === 0 || page === 0 || page === undefined) {
        allMissingPostalCodes = await API.get('orders', `/prod/missing-postal-codes`, {
            headers: {
                Authorization: await getToken(),
            },
        });

        allMissingPostalCodes.sort((a, b) => (a.totalMiss > b.totalMiss ? -1 : b.totalMiss > a.totalMiss ? 1 : 0));
    }

    if (search) {
        search = search.toLowerCase();
        let filteredData = allMissingPostalCodes.filter((line) => {
            for (let k of Object.keys(line)) {
                if (typeof line[k] === 'string') {
                    if (line[k].toLowerCase().indexOf(search) !== -1) return true;
                } else if (typeof line[k] === 'number') {
                    if (line[k].toString().indexOf(search) !== -1) return true;
                }
            }
            if (line.customer.name.toLowerCase().indexOf(search) !== -1) return true;
            if (line.customer.surname && line.customer.surname.toLowerCase().indexOf(search) !== -1) return true;
            if (line.customer.surname2 && line.customer.surname2.toLowerCase().indexOf(search) !== -1) return true;
            return false;
        });
        return { data: filteredData.slice(pageSize * (page - 1), pageSize * (page - 1) + pageSize), page, total: filteredData.length };
    }

    return { data: allMissingPostalCodes.slice(pageSize * (page - 1), pageSize * (page - 1) + pageSize), page, total: allMissingPostalCodes.length };
}

// Store Availability Orders per Hour
export async function getStoreAvailabilityOrdersPerHour() {
    const data = await API.get('orders', `/prod/store-availability-orders-per-hour`, {
        headers: {
            Authorization: await getToken(),
        },
    });
    return data.ordersPerHour;
}

export async function setStoreAvailabilityOrdersPerHour(ordersPerHour) {
    const data = await API.put('orders', `/prod/store-availability-orders-per-hour`, {
        headers: {
            Authorization: await getToken(),
        },
        body: { ordersPerHour },
    });
    return data.ordersPerHour;
}

// Delivery Max Orders per day
export async function getMaxOrdersPerDay() {
    const data = await API.get('orders', `/prod/delivery-max-orders-per-day`, {
        headers: {
            Authorization: await getToken(),
        },
    });
    return data.weekdays;
}

export async function setMaxOrdersPerDay(weekdays) {
    const data = await API.put('orders', `/prod/delivery-max-orders-per-day`, {
        headers: {
            Authorization: await getToken(),
        },
        body: { weekdays },
    });
    return data.weekdays;
}
